import { FormattedMessage } from 'react-intl'
import {
  MoovyContainer,
  MoovyContainerContent,
  MoovyContainerHeader,
  MoovyScrollToTop,
} from '../../components'
import SiteDetails from './siteDetails'

const Site = () => {
  return (
    <>
      <MoovyScrollToTop />
      <MoovyContainer>
        <MoovyContainerHeader>
          <FormattedMessage id="common.text.site" />
        </MoovyContainerHeader>
        <MoovyContainerContent>
          <SiteDetails />
        </MoovyContainerContent>
      </MoovyContainer>
    </>
  )
}

export default Site
